<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div
	class="light-container light-container--border-blue passive-plan-prompt vertical-adjustment above-canvas"
	data-element-type="none"
>
	<div class="passive-plan-prompt-description light-container__text-block">
		Selection includes started or completed tickets, which may only move vertically.
	</div>
	<div class="passive-plan-prompt-button" (click)="unselect()">
		<i>Tap here to exclude completed tickets and move freely.</i>
	</div>
</div>
